import { shallowEqual, useSelector } from 'react-redux';
import { getAccountProfile } from '../selectors';

export const useAccountProfile = () => ({
  profile: useSelector(getAccountProfile, shallowEqual),
});
